import PropTypes from "prop-types"

import Modal from "shared/components/modal"
import SMSForm from "shared/components/connection_card/mobile_alert/sms_form"

import appStoreQR from "images/web/onboarding/app_store_qr.svg"
import appStoreLogo from "images/icons/apple_appstore_download.svg"
import playStoreQR from "images/web/onboarding/play_store_qr.svg"
import playStoreLogo from "images/icons/google_play_store_download.svg"

import "./index.scss"

const DownloadModal = ({
  downloadExperimentGroup,
  downloadPlatform,
  showDownload,
  setShowDownload,
}) => {
  const appStoreDownloadUrl =
    "https://apps.apple.com/app/ifttt-automation-workflow/id660944635"
  const playStoreDownloadUrl =
    "https://play.google.com/store/apps/details?id=com.ifttt.ifttt"

  switch (downloadExperimentGroup) {
    case "control":
      return null
    case "qr_code":
      return (
        <Modal show={showDownload} closeListener={() => setShowDownload(false)}>
          <p className="txt-body-3">Scan code to get the IFTTT app</p>
          <span
            styleName="qr"
            dangerouslySetInnerHTML={{
              __html: downloadPlatform === "iOS" ? appStoreQR : playStoreQR,
            }}
          />
          <a
            styleName="store-logo"
            href={
              downloadPlatform === "iOS"
                ? appStoreDownloadUrl
                : playStoreDownloadUrl
            }
            target="_blank"
            rel="noreferrer"
          >
            <span
              dangerouslySetInnerHTML={{
                __html:
                  downloadPlatform === "iOS" ? appStoreLogo : playStoreLogo,
              }}
            />
          </a>
          <div>
            <button
              onClick={() => setShowDownload(false)}
              className="button button-tertiary"
            >
              Close
            </button>
          </div>
        </Modal>
      )
    case "sms":
      return (
        <Modal show={showDownload} closeListener={() => setShowDownload(false)}>
          <div className="mobile-alert-container">
            <p>We'll send you a link to download the IFTTT app</p>
            <SMSForm
              applet={{
                id: "platform_preference_selection",
                applet_type: downloadPlatform.toLowerCase(),
              }}
              forApplet={false}
              closeModal={() => setShowDownload(false)}
              appStorePath={appStoreDownloadUrl}
              googlePlayStorePath={playStoreDownloadUrl}
            />
          </div>
        </Modal>
      )
  }
}

DownloadModal.propTypes = {
  downloadExperimentGroup: PropTypes.string.isRequired,
  downloadPlatform: PropTypes.string.isRequired,
  showDownload: PropTypes.bool.isRequired,
  setShowDownload: PropTypes.func.isRequired,
}

export default DownloadModal
